// extracted by mini-css-extract-plugin
export default {"mui_icon":"ViewStudent_mui_icon__FhQKQ"};